import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import autoMergeLevel1 from "redux-persist/es/stateReconciler/autoMergeLevel2";
import storage from "redux-persist/lib/storage";

import patientSlice from "../../entities/patient-stats/patient-info/patient-info.slice";
import searchPatientSlice from "../../entities/search/patient/search-patient.slice";
import problemsSlice from "../../entities/patient-stats/problems/problems.slice";
import allergiesSlice from "../../entities/patient-stats/allergies/allergies.slice";
import medicationsSlice from "../../entities/patient-stats/medications/medications.slice";
import immunizationsSlice from "../../entities/patient-stats/immunizations/immunizations.slice";
import documentsSlice from "../../entities/patient-stats/documents/documents.slice";
import encountersSlice from "../../entities/patient-stats/encounters/encounters.slice";
import demographicsSlice from "../../entities/patient-stats/demographics/demographics.slice";
import encounterDocsSlice from "../../entities/patient-stats/encounters/encounter-docs.slice";

const persistConfig = {
  key: "root",
  storage,
  stateReconciler: autoMergeLevel1,
};

const encountersReducer = combineReducers({
  encountersRecords: encountersSlice,
  encounterDocs: encounterDocsSlice,
});

const rootReducer = combineReducers({
  search: searchPatientSlice,
  patient: patientSlice,
  problems: problemsSlice,
  allergies: allergiesSlice,
  medications: medicationsSlice,
  immunizations: immunizationsSlice,
  documents: documentsSlice,
  encounters: encountersReducer,
  demographics: demographicsSlice,
});

const persistedReducer = persistReducer<ReturnType<typeof rootReducer>>(
  persistConfig,
  rootReducer,
);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
